<template>
    <div class="notification legacy-app-prompt">
        <p class="notification-content">
            <template v-if="! expireDays">
                Hey, {{ user.name }}! Ready for an upgrade? <a href="https://support.fusebox.fm/article/419-upgrade">Make the switch to Fusebox 2.0</a> and unlock our brand new player!
                <a class="btn btn-primary" href="https://support.fusebox.fm/article/419-upgrade">Learn More</a>
            </template>
            <template v-else>
                Hey, {{ user.name }}! You have {{ expireDays }} days of remaining access to Fusebox 1.0. Need help? <a href="#" @click.prevent="openBeacon">Contact us</a>
            </template>
        </p>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        user: {
            type: Object,
            required: true,
        },
    },

    computed: {
        /**
         * Returns days to expire account from current date
         *
         * @returns  {*}  Days to expire
         */
        expireDays() {
            if (! this.user.migrated) {
                return false;
            }

            return moment(this.user.migrated).add(90, 'days').diff(moment(), 'days');
        },
    },

    methods: {
        /**
         * Opens helpScout Beacon
         *
         */
        openBeacon() {
            if (window.Beacon) {
                window.Beacon('open');
            }
        },
    },
};
</script>
